import { forwardRef } from 'react';
import { Typography } from '../Typography/Typography.js';
import { getTableBodyCellStyles } from './TableBodyCellStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const TableBodyCell = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    ...rest
  } = _ref;
  return jsx(Typography, {
    ref: ref,
    component: "td",
    variant: "body2",
    css: getTableBodyCellStyles,
    ...rest,
    children: children
  });
});
TableBodyCell.displayName = 'TableBodyCell';

export { TableBodyCell };
//# sourceMappingURL=TableBodyCell.js.map
